import { createRoutes } from 'shared/hocs'

import { EventView } from './view'
import { EventsOverview } from './overview'
import { EventDetails } from './details'
import { TeamSchedule } from './teamSchedule'

const Events = createRoutes(({ match }) => [
  {
    path: `${match.path}/:eventId/teams/:teamId/schedule`,
    component: TeamSchedule,
  },
  {
    path: `${match.path}/:eventId/details`,
    component: EventDetails,
  },
  {
    path: `${match.path}/:eventId`,
    component: EventView,
  },
  {
    exact: true,
    path: match.path,
    component: EventsOverview,
  },
])

export { Events }
